module.exports = __webpack_public_path__ + "static/img/title1.630c30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title1.png
// module id = qoZc
// module chunks = 26